<template>
  <div class="variables">
    <v-btn color="primary" @click="showVariables = true" small>
      <translate>New Response Type</translate>
    </v-btn>
    <v-dialog v-model="showVariables" max-width="35%" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<v-icon class="mr-1" color="primary">mdi-variable</v-icon>
          <translate>Response Types</translate>
				</v-card-title>
				<v-card-text>
					<v-btn fab color="primary" @click="showNewVariable = true" small>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
          <v-dialog v-model="showNewVariable" max-width="50%" scrollable>
            <v-card>
              <v-card-title class="title primary--text mb-2 secondary">
                <v-icon class="mr-1" color="primary">mdi-variable</v-icon>
                <translate>Create Response Type</translate>
              </v-card-title>
              <v-card-text>
                <VariableForm ref="newVariableForm" :variable="newVariable" />
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="primary" text @click="showNewVariable = false">
                  <translate>Cancel</translate>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="createVariable" :loading="saving">
                  <translate>Save</translate>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
					<p v-if="variables.length == 0" class="font-weight-thin ml-2 mt-2" v-translate>No variables.</p>
					<v-list v-else>
            <VariableItem v-for="variable in variables" :key="variable.id" :variable="variable" @delete-variable="removeVariable" />
					</v-list>
				</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="showVariables = false">
            <translate>Close</translate>
          </v-btn>
        </v-card-actions>
      </v-card>
		</v-dialog>
  </div>
</template>

<script>
import VariableForm from './VariableForm.vue'
import VariableItem from './VariableItem.vue'
import axios from "axios";

export default {
  name: "Variables",
  props: ["variables"],
  components: { 
    VariableItem,
    VariableForm
  },
  data: () => ({
    showVariables: false,
		showNewVariable: false,
    newVariable: {
      name: "",
      options: []
    },
    saving: false
  }),
  methods: {
    createVariable() {
      if(this.$refs.newVariableForm.validate()) {
        this.saving = true;
        axios
          .post("/variables/new", this.newVariable)
          .then(response => {
            console.log(response.data);
            this.variables.push(response.data.variable);
            this.newVariable.name = "";
            this.newVariable.options = [];
            this.saving = false;
            this.showNewVariable = false;
          })
          .catch(error => {
            console.log(error);
            this.saving = false;
          });
      }
    },
    removeVariable(variable) {
      this.variables.splice(this.variables.indexOf(variable), 1);
    }
  }
}
</script>